import fetchHandler from './Handler';

export const getAllReports = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/report', // Corrected endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching orders:', error); // Corrected error message
		throw new Error('Could not fetch orders. Please try again later.'); // Corrected error message
	}
};
export const getAllReportsFilter = async (
	startDate: any,
	endDate: any,
	format: any
): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/report?startDate=${startDate}&endDate=${endDate}&reportType=${format}`, // Corrected endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching orders:', error); // Corrected error message
		throw new Error('Could not fetch orders. Please try again later.'); // Corrected error message
	}
};
export const getAllReportsExport = async (
	startDate: any,
	endDate: any,
	format: any
): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/report/export?startDate=${startDate}&endDate=${endDate}&format=${format} `, // Corrected endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching orders:', error); // Corrected error message
		throw new Error('Could not fetch orders. Please try again later.'); // Corrected error message
	}
};
